module.exports = __webpack_public_path__ + "static/media/foto_brahma_03.a4ffa25b.jpg";